export default __webpack_public_path__ + "static/media/ture3.abb186df.png";